import TablaLogs from '../../components/logs/TablaLogs';

const Logs = () => (
  <div>
    <div style={{ marginBottom: '16px' }}>
      <h1 style={{ fontSize: '1.25rem', fontWeight: 700, color: '#111827', margin: 0 }}>Logs</h1>
      <p style={{ color: '#9ca3af', marginTop: '2px', marginBottom: 0, fontSize: '0.8rem' }}>
        Registro de actividad del sistema
      </p>
    </div>
    <div style={{
      backgroundColor: '#fff', borderRadius: '12px',
      border: '1px solid #e5e7eb', boxShadow: '0 1px 3px rgb(0 0 0 / 0.06)',
      padding: '16px', overflow: 'visible',
    }}>
      <TablaLogs />
    </div>
  </div>
);

export default Logs;
